/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIProcessingRequest
 */
export interface AIProcessingRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AIProcessingRequest
     */
    assets?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AIProcessingRequest
     */
    directories?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AIProcessingRequest
     */
    datasets: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AIProcessingRequest
     */
    preferredProxyProfile?: number | null;
}

export function AIProcessingRequestFromJSON(json: any): AIProcessingRequest {
    return AIProcessingRequestFromJSONTyped(json, false);
}

export function AIProcessingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIProcessingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': !exists(json, 'assets') ? undefined : json['assets'],
        'directories': !exists(json, 'directories') ? undefined : json['directories'],
        'datasets': json['datasets'],
        'preferredProxyProfile': !exists(json, 'preferred_proxy_profile') ? undefined : json['preferred_proxy_profile'],
    };
}

export function AIProcessingRequestToJSON(value?: AIProcessingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': value.assets,
        'directories': value.directories,
        'datasets': value.datasets,
        'preferred_proxy_profile': value.preferredProxyProfile,
    };
}


